import Big from 'big.js';
import _ from 'lodash';

const calculateRevenue = (hours, rate) =>
  _.isNumber(hours) && _.isNumber(rate) ? Big(hours).times(rate).toNumber() : null;
export default calculateRevenue;
